import type { Namespace } from '../types';

// DE drafted (anchors from the spec HTML: "Temperatur", "Luftfeuchte") — queued
// for native review in the task file's "DE review queue".
export const sensors = {
  title: { de: 'Sensoren', en: 'Sensors' },
  desc: {
    de: 'Live-Messwerte der Mikrocontroller des Standorts — Temperatur, Luftfeuchte, CO₂, pH und mehr',
    en: "Live probe readings reported by the site's microcontrollers — temperature, humidity, CO₂, pH and more",
  },

  statChannels: { de: 'Kanäle', en: 'Channels' },
  statReporting: { de: 'Meldend', en: 'Reporting' },

  colSensor: { de: 'Sensor', en: 'Sensor' },
  colLevel: { de: 'Ebene', en: 'Level' },
  colReading: { de: 'Messwert', en: 'Reading' },
  colStatus: { de: 'Status', en: 'Status' },
  channel: { de: 'Kanal', en: 'Channel' },
  rawReading: { de: 'Gemessen (vor Korrektur)', en: 'Measured (before correction)' },

  room: { de: 'Raum', en: 'Room' },
  rack: { de: 'Rack', en: 'Rack' },
  plumbing: { de: 'Technik', en: 'Plumbing' },
  plumbingNode: { de: 'Node', en: 'Node' },

  live: { de: 'Live', en: 'Live' },
  stale: { de: 'Veraltet', en: 'Stale' },

  loadError: { de: 'Sensoren konnten nicht geladen werden', en: "Couldn't load sensors" },
  emptyTitle: { de: 'Noch keine Sensor-Messwerte', en: 'No sensor readings yet' },
  emptyMsg: {
    de: 'Sobald ein Mikrocontroller, der einem Raum oder Rack zugewiesen ist, meldet, erscheinen seine Sensorkanäle hier automatisch.',
    en: 'Once a microcontroller assigned to a room or rack starts reporting, its sensor channels appear here automatically.',
  },
} as const satisfies Namespace;
